export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81')
];

export const server_loads = [];

export const dictionary = {
		"/": [30],
		"/account": [35,[3]],
		"/account/verify-email": [36,[3]],
		"/admin": [37,[4]],
		"/admin/achievements": [56,[4,12]],
		"/admin/achievements/new": [57,[4,12]],
		"/admin/blacklist-hits": [58,[4,13]],
		"/admin/engine": [59,[4,14]],
		"/admin/invites": [60,[4,15]],
		"/admin/jobs": [61,[4,16]],
		"/admin/settings": [62,[4,17]],
		"/admin/speakers": [63,[4,18]],
		"/admin/speakers/new": [66,[4,18]],
		"/admin/speakers/[speaker_tag]": [64,[4,18,19]],
		"/admin/speakers/[speaker_tag]/edit": [65,[4,18,19]],
		"/admin/stats": [67,[4,20]],
		"/admin/stats/[stream_tag]": [68,[4,20]],
		"/admin/streams": [69,[4,21]],
		"/admin/streams/new": [73,[4,21]],
		"/admin/streams/[stream_tag]": [70,[4,21,22]],
		"/admin/streams/[stream_tag]/edit": [71,[4,21,22]],
		"/admin/streams/[stream_tag]/refresh": [72,[4,21,22]],
		"/admin/[tag]": [38,[4,5]],
		"/admin/[tag]/achievements": [39,[4,5,6]],
		"/admin/[tag]/moderation": [40,[4,5,7]],
		"/admin/[tag]/overlay": [41,[8]],
		"/admin/[tag]/panel": [42,[4,5,9]],
		"/admin/[tag]/settings": [43,[4,5,10]],
		"/admin/[tag]/settings/broadcast": [44,[4,5,10]],
		"/admin/[tag]/settings/goals": [45,[4,5,10]],
		"/admin/[tag]/settings/image-tips": [46,[4,5,10]],
		"/admin/[tag]/settings/overlay": [47,[4,5,10]],
		"/admin/[tag]/settings/overlay/[short_id]": [48,[4,5,10]],
		"/admin/[tag]/settings/payments": [49,[4,5,10]],
		"/admin/[tag]/settings/show": [50,[4,5,10]],
		"/admin/[tag]/settings/text-tips": [51,[4,5,10]],
		"/admin/[tag]/settings/voice-tips": [52,[4,5,10]],
		"/admin/[tag]/verify-email": [53,[4,5]],
		"/admin/[tag]/voices/new": [55,[4,5,11]],
		"/admin/[tag]/voices/[voice_tag]": [54,[4,5,11]],
		"/diagnostics": [74],
		"/leaderboard": [75,[23]],
		"/onboard": [77,[25]],
		"/o/[short_id]": [76,[24]],
		"/privacy": [78,[26]],
		"/signin": [79,[27]],
		"/submission": [80,[28]],
		"/terms": [81,[29]],
		"/[tag]": [31,[2]],
		"/[tag]/image": [32,[2]],
		"/[tag]/text": [33,[2]],
		"/[tag]/voice": [34,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';